// Mining sidebar navigation.
// `badge` is the open-item count shown next to a section; `badge_variant` is "danger" or "warning".
export const default_mining_menu_item = "command-centre";

const mining_menu_items = [
  { key: "command-centre", label: "Command centre", icon: "bi bi-display", badge: 2, badge_variant: "danger" },
  { key: "shift-control", label: "Shift control", icon: "bi bi-clock-history" },
  { key: "workplaces", label: "Workplaces", icon: "bi bi-geo-alt-fill", badge: 3, badge_variant: "danger" },
  { key: "hoisting-flow", label: "Hoisting & flow", icon: "bi bi-arrow-down-up" },
  { key: "fleet", label: "Fleet", icon: "bi bi-truck", badge: 11, badge_variant: "warning" },
  { key: "maintenance", label: "Maintenance", icon: "bi bi-wrench-adjustable", badge: 5, badge_variant: "warning" },
  { key: "safety-services", label: "Safety & services", icon: "bi bi-shield-check", badge: 3, badge_variant: "danger" },
  { key: "reconciliation", label: "Reconciliation", icon: "bi bi-clipboard-check" },
  { key: "planning", label: "Planning", icon: "bi bi-calendar3" }
];

export default function get_mining_menu_items() {
  return mining_menu_items;
}
